import React from 'react';
import styled from 'styled-components';

const SrpCardRightComponent = () => (
  <SrpCardRightComponentWrapDiv>
    <FirstPricingComponentWrapDiv></FirstPricingComponentWrapDiv>
    <SecondPricingComponentWrapDiv>
      <StrikedPriceWrapDiv />
      <OriginalPriceLoaderDiv />
      <TaxLoaderDiv />
      <OfferLoaderDiv />
      <PriceBtnDiv> </PriceBtnDiv>
      <AlertWrapDiv />
    </SecondPricingComponentWrapDiv>
  </SrpCardRightComponentWrapDiv>
);

export default SrpCardRightComponent;

const SrpCardRightComponentWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  width:25%;
  padding:${props.theme.spacing.large.l15};

  justify-content: flex-end;


`,
);

const FirstPricingComponentWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  width:19.3rem;
  background-image: linear-gradient(to left, #f4f4f4, #ececec);
  border-radius:${props.theme.misc.borderRadius.xxxlarge};
  height:2.1rem;

`,
);

const SecondPricingComponentWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;
`,
);

const StrikedPriceWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  width:4.7rem;
  background-image: linear-gradient(to left, #f4f4f4, #ececec);
  border-radius:${props.theme.misc.borderRadius.small};
  height:1.4rem;
  margin-bottom:${props.theme.spacing.small.s5};

`,
);

const OriginalPriceLoaderDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  width:6.8rem;
  background-image: linear-gradient(to left, #f4f4f4, #ececec);
  border-radius:${props.theme.misc.borderRadius.small};
  height:2rem;
  margin-bottom:${props.theme.spacing.small.s5};

`,
);

const TaxLoaderDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  width:6.3rem;
  background-image: linear-gradient(to left, #f4f4f4, #ececec);
  border-radius:${props.theme.misc.borderRadius.small};
  height:2rem;
  margin-bottom:${props.theme.spacing.small.s5};

`,
);
const OfferLoaderDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  width:9.2rem;
  background-image: linear-gradient(to left, #f4f4f4, #ececec);
  border-radius:${props.theme.misc.borderRadius.small};
  height:1.4rem;
  margin-bottom:${props.theme.spacing.small.s5};

`,
);

const PriceBtnDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  width:13rem;
  background-image: linear-gradient(to left, #f4f4f4, #ececec);
  border-radius:${props.theme.misc.borderRadius.small};
  height:3.2rem;
  margin-bottom:${props.theme.spacing.small.s5};
  margin-top:${props.theme.spacing.large.l20};


`,
);

const AlertWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  width:16.1rem;
  background-image: linear-gradient(to left, #f4f4f4, #ececec);
  border-radius:${props.theme.misc.borderRadius.small};
  height:1.4rem;

`,
);
